<template>
    <div class="row">
        <div class="col-xl-6 offset-xl-3">
            <mollie-connect-form></mollie-connect-form>
        </div>
    </div>
</template>
<script>
    import {Collapse, CollapseItem, TabPane, Tabs} from '../../../components';
    import MollieConnectForm from "../../Profile/MollieConnectForm";

    export default {
        components: {
            TabPane,
            Tabs,
            Collapse,
            CollapseItem,
            MollieConnectForm
        },
        data() {
            return {
                activeName: 'first',
                model: {
                    classes: [],
                },
                modelValidations: {
                },
            };
        },
        mounted() {
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
            validate() {
                return this.$validator.validateAll().then(res => {
                    this.$emit('on-validated', res, this.model);
                    return res;
                });
            }
        }
    };
</script>
<style></style>
